"use strict";
/*
 * Copyright 2018 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultisigAccountInfo = void 0;

var catbuffer_typescript_1 = require("catbuffer-typescript");
/**
 * The multisig account graph info structure describes the information of all the mutlisig levels an account is involved in.
 */


var MultisigAccountInfo = /*#__PURE__*/function () {
  /**
   * @param version
   * @param accountAddress
   * @param minApproval
   * @param minRemoval
   * @param cosignatoryAddresses
   * @param multisigAddresses
   */
  function MultisigAccountInfo(
  /**
   * Version
   */
  version,
  /**
   * The account multisig address.
   */
  accountAddress,
  /**
   * The number of signatures needed to approve a transaction.
   */
  minApproval,
  /**
   * The number of signatures needed to remove a cosignatory.
   */
  minRemoval,
  /**
   * The multisig account cosignatories.
   */
  cosignatoryAddresses,
  /**
   * The multisig accounts this account is cosigner of.
   */
  multisigAddresses) {
    _classCallCheck(this, MultisigAccountInfo);

    this.version = version;
    this.accountAddress = accountAddress;
    this.minApproval = minApproval;
    this.minRemoval = minRemoval;
    this.cosignatoryAddresses = cosignatoryAddresses;
    this.multisigAddresses = multisigAddresses;
  }
  /**
   * Checks if the account is a multisig account.
   * @returns {boolean}
   */


  _createClass(MultisigAccountInfo, [{
    key: "isMultisig",
    value: function isMultisig() {
      return this.minRemoval !== 0 && this.minApproval !== 0;
    }
    /**
     * Checks if an account is cosignatory of the multisig account.
     * @param address
     * @returns {boolean}
     */

  }, {
    key: "hasCosigner",
    value: function hasCosigner(address) {
      return this.cosignatoryAddresses.find(function (cosigner) {
        return cosigner.equals(address);
      }) !== undefined;
    }
    /**
     * Checks if the multisig account is cosignatory of an account.
     * @param address
     * @returns {boolean}
     */

  }, {
    key: "isCosignerOfMultisigAccount",
    value: function isCosignerOfMultisigAccount(address) {
      return this.multisigAddresses.find(function (multisig) {
        return multisig.equals(address);
      }) !== undefined;
    }
    /**
     * Generate buffer
     * @return {Uint8Array}
     */

  }, {
    key: "serialize",
    value: function serialize() {
      return new catbuffer_typescript_1.MultisigEntryBuilder(this.version, this.minApproval, this.minRemoval, this.accountAddress.toBuilder(), this.cosignatoryAddresses.map(function (cosig) {
        return cosig.toBuilder();
      }), this.multisigAddresses.map(function (address) {
        return address.toBuilder();
      })).serialize();
    }
  }]);

  return MultisigAccountInfo;
}();

exports.MultisigAccountInfo = MultisigAccountInfo;